import qs from 'query-string';

import { SIGN_CALLBACK } from '~/utils/constants';

/**
 * 認証済みのときに認証ページはスキップする
 */
export default ComposedComponent => {
  const WithSignedComponent = props => {
    return <ComposedComponent {...props} />;
  };

  WithSignedComponent.getInitialProps = async ctx => {
    const { req, res } = ctx;
    const user = req && req.session ? req.session.decodedToken : null;

    if (user && user.email) {
      const callbackUrl = (() => {
        const url =
          typeof req.query[SIGN_CALLBACK] === 'string'
            ? (req.query[SIGN_CALLBACK] as string)
            : '/';
        // コールバックURLからbaseUrlとqueryを分ける
        const parsed = qs.parseUrl(url);
        const baseUrl = parsed.url;
        const baseQuery = parsed.query;

        // utmパラメータと合わせたコールバックURLを作成
        return qs.stringifyUrl({
          url: baseUrl,
          query: {
            ...baseQuery,
            utm_source: req.query['utm_source'],
            utm_medium: req.query['utm_medium'],
            utm_campaign: req.query['utm_campaign'],
          },
        });
      })();
      res.redirect(302, callbackUrl);
      return;
    }

    // Evaluate the composed component's getInitialProps().
    let composedInitialProps = {};
    if (ComposedComponent.getInitialProps) {
      composedInitialProps = await ComposedComponent.getInitialProps(ctx);
    }

    return {
      ...composedInitialProps,
      user,
    };
  };

  return WithSignedComponent;
};
